export const sxStyles = {
  accordionDetails: {
    padding: '0.75rem 0.5rem',
  },
};
